import React from 'react';
var IllustrationImage = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-homepage/static/btr-illustration_1f78ec87.svg";
import * as defaultStyles from './illustration.style';
import * as styles from './btr-illustration.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var BtrIllustration = () => ___EmotionJSX("div", {
  css: defaultStyles.illustration
}, ___EmotionJSX("div", {
  css: styles.illustrationDContainer
}, ___EmotionJSX("div", {
  css: styles.imageContainer
}, ___EmotionJSX("img", {
  src: IllustrationImage,
  css: styles.img,
  alt: "Build-to-Rent"
}))));